(function () {
    // NA
    pagination(true);
})();

(function () {
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=');
            if (cookieName === name) {
                return decodeURIComponent(cookieValue);
            }
        }
        return null;
    }

    window.addEventListener('load', function(){
        var consent = localStorage ? localStorage.getItem("_consent") : "clicked";
        var consent2 = getCookie("_consent");
        if (consent === "clicked" || consent2 === "clicked") return;
        if (typeof window["initCookieConsent"] !== "function") return;
        var cc = initCookieConsent();
        cc.run({
            onFirstAction: function(){
                if (localStorage) localStorage.setItem("_consent", "clicked");
                document.cookie = "_consent=clicked";
            },
            onAccept: function (cookie) {
                if (localStorage) localStorage.setItem("_consent", "clicked");
                document.cookie = "_consent=clicked";
            },
            current_lang: 'nl',
            autoclear_cookies: true,
            page_scripts: true,
            languages: {
                'nl': {
                    consent_modal: {
                        title: 'We gebruiken cookies',
                        description: 'Hey, "De Lommelse Gazet" maakt gebruik van cookies zodat je automatisch kunt inloggen. We zetten ook cookies van Google in om activiteiten op onze website te analyseren. <a href="/cookieverklaring/">Meer info</a>',
                        primary_btn: {
                            text: 'Accepteren',
                            role: 'accept_all'
                        },
                        secondary_btn: {
                            text: 'Weigeren',
                            role: 'accept_necessary'
                        }
                    },
                    settings_modal: {
                        blocks: []
                    }
                }
            }
        });
    });
})();

(function () {
    if (!document.body.classList.contains('post-template')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const image = cover.querySelector('.gh-cover-image');

    window.addEventListener('load', function () {
        cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        cover.classList.remove('loading');
    });
})();

(function (){
    function attachGAEvent(elm) {
        var _name = elm.getAttribute("data-ga-event");
        var _category = elm.getAttribute("data-ga-category");
        var _label = elm.getAttribute("data-ga-label");
        elm.addEventListener("click", function () {
            var _data = {
                "event_category": _category,
                "value": 1
            }
            if (_label !== null) {
                _data["event_label"] = _label;
            }
            gtag("event", _name, _data);
        });
    }

    // Attach `events` to copy link buttons
    window.addEventListener("load", function () {
        var elms = document.getElementsByClassName("gl-tooltip");
        for (var i = 0; i < elms.length; i++) {
            var link = elms[i].getElementsByTagName("a")[0];
            var text = elms[i].getElementsByTagName("span")[0];
            var attr = link.getAttribute("href");
            link.addEventListener("click", function (e) {
                e.preventDefault();
                if (window && window.navigator) {
                    window.navigator.clipboard.writeText(attr);
                }
                text.innerHTML = "Gekopieerd!";
                return false;
            });
            link.addEventListener("mouseout", function (e) {
                text.innerHTML = "Kopieer link";
            });
        }

        // Attach & push Google events
        var _elms = document.querySelectorAll("[data-ga-event]");
        for (var _i = 0; _i < _elms.length; _i++) {
            attachGAEvent(_elms[_i]);
        }
    });
})();
